import { css } from '@emotion/react'
import { eerieBlack } from '../../style/colors'

export const separatorStyle = css`
  height: 1px;
  background-color: ${eerieBlack['200']};
`
